"use strict";

const onScrollCallbacks = [];

$(() => {
  let timer;
  let wait = false;

  $(window).scroll(function () {
    if (wait) {
      return;
    }
    wait = true;

    timer = window.setTimeout(function () {
      window.clearTimeout(timer);
      onScrollCallbacks.forEach((callback, i) => {
        callback();
      });
      wait = false;
    }, 400);
  });

  const scrolledClassSetter = () => {
    if (($(document).scrollTop() - $("body .navbar").outerHeight()) >= 244) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  }
  scrolledClassSetter();
  onScrollCallbacks.push(scrolledClassSetter);
});
